var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4697 6.96967C11.7626 6.67677 12.2374 6.67677 12.5303 6.96967L16.7803 11.2196C17.0732 11.5125 17.0732 11.9874 16.7803 12.2803L12.5303 16.5303C12.2374 16.8232 11.7626 16.8232 11.4697 16.5303C11.1768 16.2374 11.1768 15.7625 11.4697 15.4696L14.4393 12.5H7C6.5858 12.5 6.25 12.1642 6.25 11.75C6.25 11.3358 6.5858 11 7 11H14.4393L11.4697 8.03027C11.1768 7.73737 11.1768 7.26257 11.4697 6.96967Z",
    fill: "#C7CBE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight24);
export default __webpack_public_path__ + "static/media/arrow-right-24.b01d7dedf3e28cae07bd604b116664e2.svg";
export { ForwardRef as ReactComponent };